"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLink = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateLink = require("@udecode/plate-link");
var useLink = function useLink(_ref) {
  var element = _ref.element;
  var editor = (0, _plateCommon.useEditorRef)();
  return {
    props: _objectSpread({}, (0, _plateLink.getLinkAttributes)(editor, element), {
      // quick fix: hovering <a> with href loses the editor focus
      onMouseOver: function onMouseOver(e) {
        e.stopPropagation();
      }
    })
  };
};
exports.useLink = useLink;